import { inject, Injectable } from '@angular/core';
import { BookmarkStore } from '../../stores/bookmark/bookmark.state';
import { Bookmark } from '../../models/bookmark';
import { makeUniqueStringArray } from '../../utility/array.utility';

@Injectable({
  providedIn: 'root',
})
export class BookmarkHelperService {
  readonly bookmarkStore = inject(BookmarkStore);

  /**
   * Extracts and returns a list of unique bookmark indicators from the given bookmark configuration.
   *
   * @param {Bookmark} bookmark - The bookmark object containing configuration details and widgets with their respective indicators.
   * @return {string[]} An array of unique bookmark indicators.
   */
  getBookmarkIndicators(bookmark: Bookmark): string[] {
    let indicators: string[] = [];
    bookmark.config.forEach(widgetConfig => {
      indicators = indicators.concat(widgetConfig.widget.indicators);
    });

    return makeUniqueStringArray(indicators);
  }

  /**
   * Retrieves unique data layer strings from the given bookmark's configuration.
   *
   * @param {Bookmark} bookmark - The bookmark object containing configuration and widget data.
   * @return {string[]} An array of unique data layer strings derived from the bookmark's widget configurations.
   */
  getBookmarkDataLayers(bookmark: Bookmark): string[] {
    let dataLayers: string[] = [];
    bookmark.config.forEach(widgetConfig => {
      dataLayers = dataLayers.concat(widgetConfig.widget.dataLayer);
    });
    return makeUniqueStringArray(dataLayers);
  }
}
